export default function filterCacheRes(hbEvents: HBEventData[]): HBEventData[] {
  try {
    const caches = [[],[],[]];
    const ret = hbEvents.filter((event, i) => {
      if (i === 0 || !event.rtiming) {
        return true;
      }
      const rtiming = event.rtiming as any;
      const cacheType = Number(rtiming?.cacheType as string);
      if (cacheType === 0 || cacheType === 1 || cacheType === 2) {
        caches[cacheType].push(event.rurl);
        return cacheType === 0;
      }
    });
    let pvEvent = ret[0];
    if (pvEvent && (caches[1].length > 0 || caches[2].length > 0)) {
      pvEvent.attrs = Object.assign({
        noCacheCount: caches[0].length,
        strCacheCount: caches[1].length,
        negCacheCount: caches[2].length,
      }, pvEvent.attrs);
    }
    return ret;
  } catch (error) {
    hbLogger.warn('filterCacheRes', error);
    return hbEvents;
  }
}
